import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { getOptimizedImageUrl } from '@/lib/image-utils';

interface CustomAvatarProps {
  src?: string;
  alt?: string;
  className?: string;
  fallbackText?: string;
  isBordered?: boolean;
}

export const CustomAvatar: React.FC<CustomAvatarProps> = ({
  src,
  alt,
  className,
  fallbackText,
  isBordered = false
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  React.useEffect(() => {
    setImageError(false);
    setImageLoaded(false);
  }, [src]);

  const handleImageError = () => {
    console.error('❌ Custom Avatar image failed to load:', src);
    setImageError(true);
  };

  const handleImageLoad = () => {
    console.log('✅ Custom Avatar image loaded successfully:', src);
    setImageLoaded(true);
  };

  const fallbackContent = fallbackText || 'U';

  return (
    <div
      className={cn(
        'relative inline-flex items-center justify-center overflow-hidden rounded-full bg-gray-100',
        isBordered && 'ring-2 ring-[#d8959b] ring-offset-2',
        className
      )}
    >
      {src && !imageError ? (
        <img
          src={getOptimizedImageUrl(src, { width: 100, quality: 80 })}
          alt={alt}
          onError={handleImageError}
          onLoad={handleImageLoad}
          className={`w-full h-full object-cover rounded-full transition-opacity duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
          loading="eager"
          referrerPolicy="no-referrer"
        />
      ) : null}

      {(!src || imageError || !imageLoaded) && (
        <div className="flex items-center justify-center w-full h-full bg-[#d8959b] text-white text-[10px] font-bold rounded-full uppercase tracking-tighter">
          {fallbackContent}
        </div>
      )}
    </div>
  );
};